/** Coerce an API response to an array, defending against a malformed/non-array
 *  body reaching state that .map()/.filter()/spread would otherwise crash on. */
export function asArray<T>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}
